import $ from 'jquery';
import {
  createCustomWidget,
  escapeAttr,
  refinementListTemplate,
  createStatsWidget,
  createSearchBoxWidget,
  createClearAllWidget,
  createSaveSearchWidget,
  createDescriptionWidget,
  createQuickListWidget,
  createPaginationWidget,
  createDatePeriodWidget
} from './base_widgets';

window.PublicIndexesProjectsWidgets = {
  getQuery() {
    const list = $('#projects-smart-lists ul#quick-lists li a.selected').data('type');
    const query = (() => {
      switch (false) {
        case list !== 'follower_ids':
          return list + `=${PublicProjectsSearch._userId}`;
        case list !== 'subscribed-projects':
          return this._subscribedProjectsQuery();
        case !list || !list.match(/^tag-/):
          return `_tags:${PublicProjectsSearch._firstTag}`;
        default: return '';
      }
    })();
    if (($('#undisclosed_budget').length === 0) || $('#undisclosed_budget').is(":checked")) {
      return $.grep([query, 'formatted_budget>=0', 'demo=0', 'creator_id=0'], Boolean).join(" AND ");
    } else {
      return $.grep([query, 'formatted_budget>0', 'demo=0', 'creator_id=0'], Boolean).join(" AND ");
    }
  },

  _subscribedProjectsQuery() {
    let [locationQuery, sectorQuery, statusQuery] = [[], [], []];
    if (allowedRegions) {
      $.each(allowedRegions, (key, region) => locationQuery.push(`location:'${region}'`));
      locationQuery = [$.grep(locationQuery, Boolean).join(" OR ")];
    }
    if (allowedSectors) {
      $.each(allowedSectors, (key, sector) => sectorQuery.push(`sectors:'${sector}'`));
      sectorQuery = [$.grep(sectorQuery, Boolean).join(" OR ")];
    }
    if (allowedStatuses) {
      $.each(allowedStatuses, (key, status) => statusQuery.push(`status_text:'${I18n.t("enumerize.project.status." + status)}'`));
      statusQuery = [$.grep(statusQuery, Boolean).join(" OR ")];
    }
    return [locationQuery, sectorQuery, statusQuery].filter(String).map(q => `(${q})`).join(" AND ");
  },

  quickListWidget() {
    return createQuickListWidget('#projects-smart-lists ul#quick-lists');
  },

  descriptionWidget() {
    return createDescriptionWidget('#description', ['title', 'plot_number', 'alias'], 'description');
  },

  undisclosedBudgetWidget() {
    return createCustomWidget({
      init(options) {
        $('#undisclosed_budget').on('click', () => options.helper.search());
      }
    });
  },

  companyActivitiesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#company_activities',
      attribute: 'company_activities',
      limit: 10,
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  completionPercentWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#completion_percent',
      attribute: 'completion_percent',
      templates: {
        seperatorText: 'to',
        submitText: ''
      }
    });
  },

  sectorsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#sectors',
      attribute: 'sectors',
      operator: 'or',
      limit: 10,
      showMore: true,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  categoryWidget() {
    return instantsearch.widgets.refinementList({
      container: '#project-categories',
      attribute: 'categories',
      operator: 'or',
      limit: 10,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  createDateWidget() { return createDatePeriodWidget('#created_at_from', '#created_at_to')({ attribute: 'created_at' }); },
  updateDateWidget() { return createDatePeriodWidget('#updated_at_from', '#updated_at_to')({ attribute: 'updated_at' }); },
  startDateWidget() { return createDatePeriodWidget('#started_at_from', '#started_at_to')({ attribute: 'started_at' }); },
  endDateWidget() { return createDatePeriodWidget('#ended_at_from', '#ended_at_to')({ attribute: 'ended_at' }); },

  dateWidget(field) {
    const fieldId = field.split(".")[0];
    return createDatePeriodWidget(`#${fieldId}_from`, `#${fieldId}_to`)({ attribute: field });
  },

  confidentialProjectsCountWidget() {
    return instantsearch.widgets.stats({
      container: '#confidential-projects',
      templates: {
        text(data) { return $('#confidential-projects-template').text(); }
      }
    });
  },

  statsWidget() {
    return createStatsWidget();
  },

  searchBoxWidget() {
    return createSearchBoxWidget({ placeholder: 'Search for projects...' });
  },

  locationWidget() {
    return instantsearch.widgets.refinementList({
      container: '#location',
      attribute: 'location',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  userTagsWidget(userId) {
    return instantsearch.widgets.refinementList({
      container: '#user-tags',
      attribute: "user_tags." + userId,
      operator: 'or',
      limit: 5,
      showMore: true,
      showMoreLimit: 5000,
      searchable: false,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined', 'count:desc', 'name:asc'],
      templates: { item: refinementListTemplate }
    });
  },

  statusWidget() {
    const orderdedStatus = ['In planning', 'In Design', 'In Tender', 'Under Construction', 'Completed', 'Cancelled', 'On Hold'];
    return instantsearch.widgets.refinementList({
      container: '#status',
      attribute: 'status_text',
      operator: 'or',
      limit: 10,
      templates: {
        item(hit) {
          return `<label class='ais-RefinementList-label'><input type='checkbox' class='ais-RefinementList-checkbox' value="${escapeAttr(hit.value)}" ${hit.isRefined ? 'checked' : ''}><span class='status-label label-project-status ${hit.value.toLowerCase().replace(/ /g, "_")}'>${hit.value}</span></input><span class='ais-RefinementList-count'>${hit.count}</span></label>`;
        }
      },
      sortBy(a, b) { return orderdedStatus.indexOf(a.name) < orderdedStatus.indexOf(b.name) ? -1 : 1; }
    });
  },

  trialStatusWidget() {
    const orderdedStatus = ['Ongoing', 'Completed', 'Cancelled'];
    return instantsearch.widgets.refinementList({
      container: '#status',
      attribute: 'trial_status_text',
      operator: 'or',
      limit: 3,
      templates: {
        item(hit) {
          return `<label class='ais-RefinementList-label'><input type='checkbox' class='ais-RefinementList-checkbox' value="${escapeAttr(hit.value)}" ${hit.isRefined ? 'checked' : ''}><span class='status-label label-project-status ${hit.value.toLowerCase().replace(/ /g, "_")}'>${hit.value}</span></input><span class='ais-RefinementList-count'>${hit.count}</span></label>`;
        }
      },
      sortBy(a, b) { return orderdedStatus.indexOf(a.name) < orderdedStatus.indexOf(b.name) ? -1 : 1; }
    });
  },

  budgetPriceRangeWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#budget-range',
      attribute: 'formatted_budget_in_million',
      templates: {
        currency: '$M',
        separatorText: 'to',
        submitText: ''
      }
    });
  },

  totalScoreRangeWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#total-score',
      attribute: 'total_score',
      templates: {
        separatorText: 'to',
        submitText: ''
      }
    });
  },

  heightWidget() {
    const orderdedHeight = ['Low-Rise', 'Mid-Rise', 'High-Rise', 'Super-Tall'];
    return instantsearch.widgets.refinementList({
      container: '#project-height',
      attribute: 'height',
      operator: 'or',
      sortBy(a, b) { return orderdedHeight.indexOf(a.name) < orderdedHeight.indexOf(b.name) ? -1 : 1; }
    });
  },

  developersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#developers',
      attribute: 'developers',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search developers",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: { item: refinementListTemplate }
    });
  },

  consultantsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#consultants',
      attribute: 'consultants',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search consultants",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: { item: refinementListTemplate }
    });
  },

  contractorsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#contractors',
      attribute: 'contractors',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search contractors",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: { item: refinementListTemplate }
    });
  },

  suppliersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#suppliers',
      attribute: 'suppliers',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search suppliers",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: { item: refinementListTemplate }
    });
  },

  projectTypeWidget() {
    return instantsearch.widgets.refinementList({
      container: '#project_types',
      attribute: 'project_type.label',
      sortBy: ['isRefined'],
      limit: 10,
      templates: { item: refinementListTemplate }
    });
  },

  clearAllWidget(exclude) {
    return createClearAllWidget({
      label: 'Clear filters',
      excludedAttributes: exclude || [],
      clearsQuery: true
    });
  },

  saveSearchWidget() {
    return createSaveSearchWidget({ buttonTag: 'div' });
  },

  singleHitsWidget(klass, view, userId, controller, isSelfCompany, company, trial, userMembership) {
    const renderHits = (renderOptions, isFirstRender) => {
      if (isFirstRender) return;
      const items = renderOptions.hits.map(item => {
        if (userId) {
          item.tagged = item.user_tags[userId];
        }
        if (item.follower_ids.indexOf(userId) >= 0) {
          item.liked = true;
        }
        if (!isSelfCompany) {
          const status = this._projectStatus(userMembership, trial, item);
          item.status = status[0];
          item.status_text = status[1];
        }
        if (controller === 'company_projects') {
          this._setParticipationStateAndUrl(item, isSelfCompany, company);
        }
        return item;
      });

      if (PublicProjectsIndex._pivotMode) {
        const nbPages = parseInt(renderOptions.results.nbHits / 1000, 10) + 1;
        const client = klass._searchObject.helper.getClient();

        if (items.length > 0) {
          const rand = _.random(999999);
          const onSearchResponse = response => {
            return _.each(response.results, result => PublicProjectsIndex.loadData(result, rand));
          };

          PublicProjectsIndex.clearData(rand);

          const queryGroups = _.map(this._generatePageGroups(nbPages, { groupsOf: 5 }), pageGroup => _.map(pageGroup, pageNumber => ({
            query: klass._searchObject.helper.getQuery().query,
            params: _.extend(klass._searchObject.helper.getQuery(), {
              hitsPerPage: 1000,
              attributesToHighlight: [],
              page: pageNumber
            }),
            indexName: klass._searchObject.indexName
          })));

          _.each(queryGroups, queryGroup => client.search(queryGroup).then(onSearchResponse));
        } else {
          PublicProjectsIndex.loadNoData();
        }
      } else {
        PublicProjectsIndex.loadSinglePageData(items);
      }
      return items;
    };
    return instantsearch.connectors.connectHits(renderHits);
  },

  hitsWidget(view, userId, controller, userMembership, isSelfCompany, company, trial) {
    userId = parseInt(userId, 10);
    const container = `#projects-${view}`;

    const listClasses = userId
      ? { list: 'grid items borders ais-Hits-list', root: 'ais-Hits', item: 'item' }
      : { list: 'ais-Hits-list ', root: 'grid clearfix show ais-Hits', item: 'item' };

    if (userId && (view === 'grid') && (GridListToggler.getViewMode() === 'grid')) {
      listClasses['list'] += ' vertical';
    }

    return instantsearch.widgets.infiniteHits({
      empty: 'Oops, no results were found',
      container,
      transformItems: items => {
        items.map(item => {
          if (userId) { item.tagged = item.user_tags[userId]; }
          if (item.follower_ids.indexOf(userId) >= 0) { item.liked = true; }
          if (!isSelfCompany) {
            const status = this._projectStatus(userMembership, trial, item);
            item.status = status[0];
            item.status_text = status[1];
          }
          if (controller === 'company_projects') {
            this._setParticipationStateAndUrl(item, isSelfCompany, company);
          }
          if (item.total_score >= 70) { item.par_score = true; }
          return item;
        });
        return items;
      },
      templates: {
        item: $(`#project-${view}-template`).text(),
        empty: $('#no-search-results-found-template').text()
      },
      cssClasses: listClasses
    });
  },

  paginationWidget() {
    return createPaginationWidget();
  },

  _compactAndJoin(arr) {
    return _.compact(arr).join('_');
  },

  _sortingOptions(indexName, prefix, env, userMembership, protenders) {
    const options = [
      { value: indexName, label: 'Most Relevant' },
      { value: this._compactAndJoin([prefix, 'projects_by_ended_at_desc', env]), label: 'Completed Date' },
      { value: this._compactAndJoin([prefix, 'projects_by_updated_at_desc', env]), label: 'Date Updated' },
      { value: this._compactAndJoin([prefix, 'projects_by_budget_desc', env]), label: 'Budget' },
      { value: this._compactAndJoin([prefix, 'projects_by_number_of_participants_desc', env]), label: 'Participants' },
      { value: this._compactAndJoin([prefix, 'projects_by_latest_event_created_at_desc', env]), label: 'Construction Updates' }
    ];
    if (userMembership === 'insights') {
      options.splice(3, 0, { value: this._compactAndJoin([prefix, 'projects_by_status_asc', env]), label: 'Status' });
    }
    if (protenders) {
      options.splice(options.length, 0, { value: this._compactAndJoin([prefix, 'projects_by_total_score_desc', env]), label: 'Total Score' });
    }
    return options;
  },

  sortBySelectorWidget(indexName, prefix, env, userMembership, protenders) {
    return instantsearch.widgets.sortBy({
      container: '#sort-by-container',
      items: this._sortingOptions(indexName, prefix, env, userMembership, protenders)
    });
  },

  _setParticipationStateAndUrl(item, isSelfCompany, company) {
    const url = "projects/" + item.slug;
    if (item.verified_participants.indexOf(company.id) >= 0) {
      return item.url = `/companies/${company.slug}/projects/` + item.slug;
    } else if (isSelfCompany) {
      let participant;
      if (item.creator_id === company.id) {
        item.owner_participation = true;
        return item.url = `/companies/${company.slug}/projects/` + item.slug;
      } else if (participant = (item.pending_participants.find(p => p.company_id === company.id))) {
        item.pending_participation = true;
        return item.url = "/companies/" + item.creator_id + "/projects/" + item.slug + "?verification_token=" + participant.verification_token;
      } else if (item.requested_participants.indexOf(company.id) >= 0) {
        item.requested_participation = true;
        return item.url = "/projects/" + item.slug;
      }
    }
  },

  _projectStatus(userMembership, trial, item) {
    let status, status_text;
    if (this._showStatus(userMembership, item)) {
      if (trial && ($.inArray(item.status, ['tender', 'planning', 'under_design', 'under_construction', 'on_hold']) !== -1)) {
        status = 'ongoing';
        status_text = 'Ongoing';
      } else {
        ({ status } = item);
        ({ status_text } = item);
      }
    } else {
      status = '';
      status_text = '';
    }
    return Array(status, status_text);
  },

  _showStatus(userMembership, item) {
    return (userMembership === 'insights') &&
      ((allowedRegions.length === 0) || item.location.some(r => allowedRegions.includes(r))) &&
      ((allowedSectors.length === 0) || item.sectors.some(r => allowedSectors.includes(r))) &&
      ((allowedStatuses.length === 0) || allowedStatuses.some(r => r === item.status));
  },

  _generatePageGroups(number, options) {
    return _.values(_.groupBy(_.range(number), (i => Math.floor(i / options.groupsOf))));
  },

  initAsyncHitsLoading(klass, instantSearchInstance, indexName) {
    const mapLoader = MapLoader.initialize(map, instantSearchInstance.client, indexName, {
      isSelfCompany: typeof isSelfCompany !== 'undefined' ? isSelfCompany : false,
      userMembership: typeof user_membership !== 'undefined' ? user_membership : '',
      trial: typeof trial !== 'undefined' ? trial : false
    });
    return instantsearch.widgets.asyncHitsLoading = o => {
      return {
        render: options => {
          const nbPages = parseInt(options.results.nbHits / 1000, 10) + 1;
          markers.clearLayers();
          map.removeLayer(markers);
          $(map.getContainer()).show();
          map.spin(false);
          map.spin(true, { className: 'spin-spinner', color: '#333', width: 4 });

          if (options.results.nbHits > 0) {
            $('#no-search-results-found-template').hide();
            const queryGroups = _.map(this._generatePageGroups(nbPages, { groupsOf: 5 }), pageGroup => _.map(pageGroup, pageNumber => ({
              query: options.helper.getQuery().query,
              params: _.extend(options.helper.getQuery(), {
                hitsPerPage: 1000,
                responseFields: ['hits', 'page'],
                attributesToRetrieve: ['objectID', '_geoloc', 'status', 'icon_type'],
                attributesToHighlight: [],
                page: pageNumber
              }),
              indexName: options.helper.getIndex()
            })));
            return mapLoader.load(queryGroups, nbPages);
          } else {
            map.spin(false);
            $(map.getContainer()).hide();
            return $('#no-search-results-found-template').show();
          }
        }
      };
    };
  },

  initAsyncHitsLoadingBreakdown() {
    return instantsearch.widgets.asyncHitsLoadingBreakdown = options => ({
      render(options) {
        const nbPages = Math.ceil(options.results.nbHits / 1000);
        if (options.results.nbHits > 0) {
          const timestamp = performance.now();
          const onSearchResponse = function (response) {
            ProjectsBreakdown.loadData(response, timestamp);
          };

          for (let i = 0, end = nbPages, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            if (i === 0) {
              ProjectsBreakdown.clearData(timestamp, nbPages);
            }
            options.helper.searchOnce({
              hitsPerPage: 1000,
              attributesToHighlight: [],
              attributesToRetrieve: [
                'location', 'sectors', 'status', 'display_sectors',
                'formatted_budget', 'ended_at', 'main_contractor_awarded_at',
                'sectors_budget', 'consultants', 'contractors', 'developers',
                'suppliers', 'project_type'
              ],
              page: i
            }).then(onSearchResponse);
          }
        } else {
          ProjectsBreakdown.loadNoData();
        }
      }
    });
  }
};
